import moment from 'moment';
import 'moment-timezone';
export default {
  props: {
    customSlotVisible: {
      type: Boolean,
      default: false
    }
  },
  mounted() {
    this.checkMobile();
    window.addEventListener('resize', this.checkMobile);
    const adPic = this.calShowAdPic();
    console.log('cal pic:');
    console.log(adPic);
    this.adPic = adPic;
  },
  destroyed() {
    window.removeEventListener('resize', this.checkMobile);
  },
  computed: {},
  data() {
    return {
      visible: false,
      isMobile: false,
      adPic: null
    };
  },
  watch: {
    customSlotVisible(newVal, oldVal) {
      console.log(newVal, ' customSlotVisible');
      if (!this.adPic) {
        return;
      }
      if (newVal) {
        this.visible = true;
      } else {
        this.visible = false;
      }
    }
  },
  methods: {
    checkMobile() {
      let width = document.documentElement.clientWidth || document.body.clientWidth;
      if (width <= 980) {
        this.isMobile = true;
      } else {
        this.isMobile = false;
      }
    },
    cancelFn() {
      this.$emit("cancel");
    },
    confirmFn() {
      this.$emit("confirm");
    },
    calShowAdPic() {
      // 4/29发倒计时
      // 4/30一5/3下午4点发通告1
      // 5/4-5/10发通告2
      // 5/11-5/20发通告3

      let isKoreas = false;
      const languageKey = localStorage.getItem('lang');
      if (languageKey == 'Kr') {
        isKoreas = true;
      }

      // Set the timezone to Singapore (GMT+8)
      const now = moment().tz('Asia/Singapore');

      // Notification schedule in Singapore Time
      const countdownDate = moment.tz('2025-04-29', 'Asia/Singapore').endOf('day');
      const notice1Start = moment.tz('2025-04-30', 'Asia/Singapore').startOf('day');
      const notice1End = moment.tz('2025-05-03', 'Asia/Singapore').set({
        hour: 16,
        minute: 0,
        second: 0
      });
      const notice2Start = moment.tz('2025-05-04', 'Asia/Singapore').startOf('day');
      const notice2End = moment.tz('2025-05-10', 'Asia/Singapore').endOf('day');
      const notice3Start = moment.tz('2025-05-11', 'Asia/Singapore').startOf('day');
      const notice3End = moment.tz('2025-05-20', 'Asia/Singapore').endOf('day');
      console.log(now.isBetween(notice1Start, notice1End, null, '[]'));
      let resultImg = null;
      if (now.isBefore(countdownDate)) {
        // Before April 29 - Countdown period
        if (isKoreas) {
          resultImg = require('@/assets/images/enter-activity-countdown-day2-kr.jpg');
        } else {
          resultImg = require('@/assets/images/enter-activity-countdown-day2-zh.jpg');
        }
      } else if (now.isBetween(notice1Start, notice1End, null, '[]')) {
        // April 30 - May 3 4:00 PM - Notice 1 period
        if (isKoreas) {
          resultImg = require('@/assets/images/enter-activity-notice1-kr.jpg');
        } else {
          resultImg = require('@/assets/images/enter-activity-notice1-zh.jpg');
        }
      } else if (now.isBetween(notice2Start, notice2End, null, '[]')) {
        // May 4 - May 10 - Notice 2 period
        if (isKoreas) {
          resultImg = require('@/assets/images/enter-activity-notice2-kr.jpg');
        } else {
          resultImg = require('@/assets/images/enter-activity-notice2-zh.jpg');
        }
      } else if (now.isBetween(notice3Start, notice3End, null, '[]')) {
        // May 11 - May 20 - Notice 3 period
        if (isKoreas) {
          resultImg = require('@/assets/images/enter-activity-notice3-kr.jpg');
        } else {
          resultImg = require('@/assets/images/enter-activity-notice3-zh.jpg');
        }
      }
      console.log(resultImg);
      return resultImg;
    }
  }
};